'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JwtAuthorization = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bluebird = require('bluebird');

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _UserInfo = require('./UserInfo');

var _AuthenticatedState = require('./AuthenticatedState');

var _AuthenticatedState2 = _interopRequireDefault(_AuthenticatedState);

var _LoginState = require('./LoginState');

var _LoginState2 = _interopRequireDefault(_LoginState);

var _RegistrationModel = require('./RegistrationModel');

var _RegistrationModel2 = _interopRequireDefault(_RegistrationModel);

var _AbstractAuthorization = require('./AbstractAuthorization');

var _AbstractAuthorization2 = _interopRequireDefault(_AbstractAuthorization);

var _SessionService = require('./SessionService');

var _SessionService2 = _interopRequireDefault(_SessionService);

var _TokenCookieStorage = require('./TokenCookieStorage');

var _TokenCookieStorage2 = _interopRequireDefault(_TokenCookieStorage);

var _decodeJwtToken = require('./decodeJwtToken');

var _decodeJwtToken2 = _interopRequireDefault(_decodeJwtToken);

var _AuthenticationViewWrapper = require('./AuthenticationViewWrapper');

var _AuthenticationViewWrapper2 = _interopRequireDefault(_AuthenticationViewWrapper);

var _AuthorizeByFirstFactorCommandClass = require('./AuthorizeByFirstFactorCommandClass');

var _AuthorizeByFirstFactorCommandClass2 = _interopRequireDefault(_AuthorizeByFirstFactorCommandClass);

var _AuthorizeBySecondFactorCommandClass = require('./AuthorizeBySecondFactorCommandClass');

var _AuthorizeBySecondFactorCommandClass2 = _interopRequireDefault(_AuthorizeBySecondFactorCommandClass);

var _LoginStage = require('./LoginStage');

var _LoginCodeSource = require('./LoginCodeSource');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// 5 sec each
var TIME_SKEW = 5;
var MIN_VALIDITY = 35;

// TODO: wtf with returned resolve / reject ?
/* eslint consistent-return: 0 */

var JwtAuthorization = exports.JwtAuthorization = function (_AbstractAuthorizatio) {
  _inherits(JwtAuthorization, _AbstractAuthorizatio);

  function JwtAuthorization(keycloakJson, logger, authenticationComponent, access_token, refresh_token) {
    _classCallCheck(this, JwtAuthorization);

    var _this = _possibleConstructorReturn(this, (JwtAuthorization.__proto__ || Object.getPrototypeOf(JwtAuthorization)).call(this));

    _this.logger = logger || _auroraJavascriptUtils.log.getLogger('JwtAuthorization');

    _this._sessionService = new _SessionService2.default(keycloakJson['auth-server-url'], keycloakJson.realm, keycloakJson.resource, TIME_SKEW, MIN_VALIDITY);
    _this._tokenCookieStorage = new _TokenCookieStorage2.default();
    _this._authenticationComponent = authenticationComponent;

    _this._accessToken = access_token || null;
    _this._refreshToken = (0, _decodeJwtToken2.default)(refresh_token);
    _this._tokenParsed = (0, _decodeJwtToken2.default)(access_token);
    _this._refreshTokenParsed = null;
    _this._scheduledRefreshId = null;

    _this._initialized = false;
    _this._authenticationState = new _AuthenticatedState2.default();
    _this._userInfo = new _UserInfo.UserInfo();
    _this._loginState = new _LoginState2.default();
    _this._registrationState = new _RegistrationModel2.default();
    _this._options = {};

    _this._authorizationPromise = _this._tryHandleSavedTokens().then(function () {
      _this.logger.info('authorization initialization succeed');
      _this._initialized = true;
    }).catch(function (err) {
      _this.logger.error('handleSavedTokens failed');
      _this._initialized = true;
      _this.dropTokens();
    });

    return _this;
  }

  _createClass(JwtAuthorization, [{
    key: '_assertInitialized',
    value: function _assertInitialized() {
      if (!this._initialized) {
        throw new Error('KeycloakAuthorization not initialized!');
      }
    }
  }, {
    key: 'getAuthenticationComponent',
    value: function getAuthenticationComponent() {
      return _react2.default.createElement(_AuthenticationViewWrapper2.default, { loginState: this._loginState,
        registrationState: this._registrationState,
        authenticationComponent: this._authenticationComponent });
    }
  }, {
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      if (!this._initialized) {
        return false;
      };

      return this._authenticationState.isAuthenticated;
    }
  }, {
    key: 'login',
    value: function login() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._assertInitialized();
      this._registrationState.hide();
      this._options = options;

      if (!this._loginPromise) {
        this._loginPromise = new _bluebird.Promise(function (resolve) {

          _this2._loginState.set({
            stage: _LoginStage.LoginStage.LOGIN_AND_PASSWORD,
            authorizeByFirstFactorCommand: new _AuthorizeByFirstFactorCommandClass2.default({
              executor: function executor(req) {
                return _this2._authorizeByFirstFactor(req.username, req.password, 'UTCOM', options.locale);
              }
            }),
            authorizeBySecondFactorCommand: new _AuthorizeBySecondFactorCommandClass2.default({
              executor: function executor(req) {
                return _this2._authorizeBySecondFactor(req.code);
              }
            })
          });

          var onClose = function onClose(_, newValue) {
            if (!newValue) {
              resolve();
              _this2._loginPromise = null;
              _this2._loginState.off('change:stage', onClose);
            }
          };

          _this2._loginState.on('change:stage', onClose);
        });
      }

      return this._loginPromise;
    }
  }, {
    key: 'authorizeByFirstFactor',
    value: function authorizeByFirstFactor(username, password, product, locale) {
      this._authorizeByFirstFactor(username, password, product, locale);
    }
  }, {
    key: 'register',
    value: function register() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._assertInitialized();
      this._options = options;

      this._loginState.hide();
      this._registrationState.show();
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      return this._options;
    }
  }, {
    key: '_authorizeByFirstFactor',
    value: function _authorizeByFirstFactor(username, password, product, locale) {
      var _this3 = this;

      this._assertInitialized();

      return this._sessionService.authorizeByFirstFactor(username, password, product, locale).then(function (response) {
        if (response.otpType !== 'OTP_DISABLED') {
          _this3._loginState.set({
            stage: _LoginStage.LoginStage.CODE,
            codeSource: response.otpType === 'OTP_EMAIL' ? _LoginCodeSource.LoginCodeSource.EMAIL : _LoginCodeSource.LoginCodeSource.GA,
            secondFactorRequestId: response.secondFactorRequestId
          });
          return response;
        }
        _this3._loginState.hide();
        return _this3.authenticateWithTokens({
          access_token: response.tokens.accessToken,
          refresh_token: response.tokens.refreshToken
        });
      }).catch(function (loadTokenErr) {
        if (loadTokenErr.status !== 401) {
          _this3.logger.error('Cannot obtain direct tokens');
        }
        throw loadTokenErr;
      });
    }
  }, {
    key: '_authorizeBySecondFactor',
    value: function _authorizeBySecondFactor(code) {
      var _this4 = this;

      this._assertInitialized();

      return this._sessionService.authorizeBySecondFactor(this._loginState.secondFactorRequestId, code).then(function (response) {
        _this4._loginState.hide();
        return _this4.authenticateWithTokens({
          access_token: response.accessToken,
          refresh_token: response.refreshToken
        });
      }).catch(function (loadTokenErr) {
        if (loadTokenErr.status !== 401) {
          _this4.logger.error('Cannot obtain direct tokens');
        }
        throw loadTokenErr;
      });
    }
  }, {
    key: 'authenticateWithTokens',
    value: function authenticateWithTokens(tokensInfo) {
      var _this5 = this;

      return new _bluebird.Promise(function (resolve) {
        _this5._setTokens(tokensInfo);
        _this5._userInfo.set({ user_id: _this5._tokenParsed.user_id });
        _this5._authenticationState.set({ isAuthenticated: true });
        resolve();
      });
    }
  }, {
    key: '_setTokens',
    value: function _setTokens(tokensInfo, rejectScheduledRefresh) {
      var _this6 = this;

      this._tokenParsed = (0, _decodeJwtToken2.default)(tokensInfo.access_token);

      this._accessToken = tokensInfo.access_token;
      this._refreshToken = tokensInfo.refresh_token;

      this._tokenCookieStorage.save(tokensInfo);

      var logger = this.logger;
      var needRefreshIn = Math.max(this._tokenParsed.exp - Math.ceil(new Date().getTime() / 1000), 30); // min 30 sec
      if (!this._scheduledRefreshId && !rejectScheduledRefresh) {
        this._scheduledRefreshId = setInterval(function () {
          _this6._sessionService.refreshTokens(_this6._tokenParsed, _this6._refreshToken, function (err, refreshedTokensInfo) {
            if (err || !refreshedTokensInfo) {
              logger.info('can\'t update token');
              return;
            }

            _this6._setTokens({
              access_token: refreshedTokensInfo.accessToken,
              refresh_token: refreshedTokensInfo.refreshToken
            });
            logger.info('access token updated by schedule');
          });
        }, needRefreshIn * 1000);
      }
    }
  }, {
    key: '_tryHandleSavedTokens',
    value: function _tryHandleSavedTokens() {
      var _this7 = this;

      return new _bluebird.Promise(function (resolve, reject) {
        if (_this7._accessToken) {
          return _this7.authenticateWithTokens({ access_token: _this7._accessToken, refresh_token: null }).then(resolve).catch(reject);
        }
        var tokensInfo = _this7._tokenCookieStorage.get();

        if (!tokensInfo.access_token) {
          _this7.logger.info('no tokens in cookies');
          return resolve();
        }

        var accessTokenParsed = (0, _decodeJwtToken2.default)(tokensInfo.access_token);
        if (!_this7.isTokenExpired(accessTokenParsed.exp)) {
          _this7.logger.info('tokens obtained from cookies and used');
          return _this7.authenticateWithTokens(tokensInfo).then(resolve).catch(reject);
        }

        var refreshTokenParsed = (0, _decodeJwtToken2.default)(tokensInfo.refresh_token);
        if (_this7.isTokenExpired(refreshTokenParsed.exp)) {
          _this7._tokenCookieStorage.drop();
          _this7.logger.info('tokens obtained from cookies, but staled so far');
          return resolve();
        }

        _this7._setTokens(tokensInfo, true);
        _this7._sessionService.refreshTokens(_this7._tokenParsed, _this7._refreshToken, function (err, tokensInfo) {
          if (err || !tokensInfo) {
            return reject(new Error('can\'t update token'));
          }

          _this7.logger.info('tokens obtained from cookies and updated');
          _this7.authenticateWithTokens(tokensInfo).then(function () {
            return resolve();
          }).catch(function (authErr) {
            return reject(authErr);
          });
        });
      });
    }
  }, {
    key: 'dropTokens',
    value: function dropTokens() {
      this._accessToken = null;
      this._refreshToken = null;

      this._tokenParsed = null;
      this._refreshTokenParsed = null;

      this._tokenCookieStorage.drop();
      clearInterval(this._scheduledRefreshId);
      this._scheduledRefreshId = null;
    }
  }, {
    key: 'isTokenExpired',
    value: function isTokenExpired(tokenExpirationTime) {
      var expiresIn = tokenExpirationTime - Math.ceil(new Date().getTime() / 1000) + TIME_SKEW - MIN_VALIDITY;
      return expiresIn < 0;
    }
  }, {
    key: 'getRoles',
    value: function getRoles() {
      this._assertInitialized();

      if (!this._tokenParsed) {
        throw new Error('Access token was not parsed correctly');
      }

      return this._tokenParsed.realm_access.roles;
    }
  }, {
    key: 'logout',
    value: function logout() {
      this._assertInitialized();

      if (!this._authenticationState.isAuthenticated) {
        throw new Error('not authenticated!');
      }

      this._sessionService.logout(this._refreshToken);

      this._authenticationState.set({ isAuthenticated: false });
      this.dropTokens();
      this._userInfo.set({});
    }
  }, {
    key: 'getAuthorizationPromise',
    value: function getAuthorizationPromise() {
      return this._authorizationPromise;
    }
  }, {
    key: 'getUserInfo',
    value: function getUserInfo() {
      this._assertInitialized();

      return this._userInfo;
    }
  }, {
    key: 'getAuthenticationState',
    value: function getAuthenticationState() {
      return this._authenticationState;
    }
  }, {
    key: 'getCheckedAccessToken',
    value: function getCheckedAccessToken() {
      var _this8 = this;

      this._assertInitialized();
      return new _bluebird.Promise(function (resolve, reject) {
        if (!_this8._authenticationState.isAuthenticated) {
          resolve(null);
          return;
        }

        if (_this8.isTokenExpired(_this8._tokenParsed.exp)) {
          _this8.logger.warn('Token expired! Current client time is ' + new Date().getTime() / 1000 + 'sec, token exp = ' + _this8._tokenParsed.exp + 'sec');
          _this8._sessionService.refreshTokens(_this8._tokenParsed, _this8._refreshToken, function (err, tokensInfo) {
            if (err || !tokensInfo) {
              return reject(new Error('can\'t update token'));
            }

            _this8._setTokens({
              access_token: tokensInfo.accessToken,
              refresh_token: tokensInfo.refreshToken
            });
            resolve(_this8._accessToken);
          });
        } else {
          resolve(_this8._accessToken);
        }
      });
    }
  }, {
    key: 'getAccessToken',
    value: function getAccessToken() {
      return this._accessToken;
    }
  }, {
    key: 'getAuthorizationHeaderValue',
    value: function getAuthorizationHeaderValue() {
      this._assertInitialized();

      return this.getCheckedAccessToken().then(function (token) {
        return token ? 'Bearer ' + token : '';
      });
    }
  }]);

  return JwtAuthorization;
}(_AbstractAuthorization2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/authorization/JwtAuthorization.js
// module id = 1319
// module chunks = 118